import React from 'react'
import { connect } from 'react-redux'
import { doGetShiftList } from '../../reducers/actions'
import ShiftDiv from './ShiftDiv'
class ShiftList extends React.Component {
    state = {}
    componentDidMount = () => {
        this.handleInitShift()
    }
    handleInitShift = () => {
        const { onSave, onClose, dispatch } = this.props
        dispatch(doGetShiftList({
            onEnd: ({ errorMessage, initValues基本信息 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else if (initValues基本信息) {
                    this.setState({ initValues基本信息 })
                }
            }
        }))
    }

    handleAddShift = (data) => {
        Tyan.pubForm.showDialog('班别设置', props => <ShiftDiv {...props} id={-1} onSave={this.handleInitShift} />)
        this.setState({})
    }

    handleEditShift = (data) => {
        Tyan.pubForm.showDialog('班别设置', props => <ShiftDiv {...props} id={data.id} onSave={this.handleInitShift} />)
        this.setState({})
    }

    handlerClose = () => {
        const { onClose } = this.props
        onClose && onClose()
    }

    fieldset模板 = () => {
        return [{
            _grid: '', name: '班别', rowNumbers: true, minRows: 5,
            columns: [
                { _text: '班别', minWidth: 300, flex: 1 },
                { _text: '上午', minWidth: 300, flex: 1 },
                { _text: '下午', minWidth: 300, flex: 1 },
            ],
            onDoubleTap: this.handleEditShift,
        }]
    }

    render = () => {
        const { showBody: Body } = this.props

        return <Body data={this} maxWidth={1200}
            controls={
                [
                    { _button: '添加', handler: this.handleAddShift },
                    { _button: '关闭', handler: this.handlerClose },
                ]}
            fieldsets={[
                { title: '', name: '基本信息', _fieldset: this.fieldset模板(), /* docked: 'top',  */flex: 1 },
            ]}
        />
    }
}

export default connect()(ShiftList)